import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUserData } from "../../redux/selectors";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Flex,
  useDisclosure,
  useToast,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  Box,
  Button,
} from "@chakra-ui/react";
import {
  FaTimes,
  FaHome,
  FaUser,
  FaFileAlt,
  FaGift,
  FaSlidersH,
  FaClipboardList,
  FaLock,
  FaSignOutAlt,
  FaArrowLeft,
} from "react-icons/fa";
import { HiOutlineMenuAlt2 } from "react-icons/hi";
import { MdAddCard } from "react-icons/md";
import Rules from "./Rules";
import BonusRules from "./BonusRules";
import LogoWhite from "../../assets/img/logo-white.png";
import SportsNavStrip from "./SportsNavStrip";
import MobileLiveBar from "./MobileLiveBar";
import AnnouncementBar from "../../pages/LandingPage/AnnouncementBar";
import "./header.css";

const MobileHeader = ({ setIsSidebarOpen, hideSportsNav }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userData = useSelector(selectUserData);
  const isGamePage = location.pathname.includes('/game/');
  const isCasinoPage = location.pathname === '/live-casino' || location.pathname.startsWith('/diamond-casino/play');
  const isReportPage = location.pathname.startsWith('/report/') || location.pathname === '/account';
  const showBackArrow = isCasinoPage || isReportPage;
  const toast = useToast();
  const { isOpen: rulesOpen, onOpen: openRules, onClose: closeRules } = useDisclosure();
  const { isOpen: bonusOpen, onOpen: openBonus, onClose: closeBonus } = useDisclosure();
  const { isOpen: drawerOpen, onOpen: openDrawer, onClose: closeDrawer } = useDisclosure();

  const rawBalance = Number(userData?.balance || 0);
  const exposure = Math.abs(Number(userData?.liability || 0)).toFixed(2);
  const balance = (rawBalance - Math.abs(Number(userData?.liability || 0))).toFixed(2);
  const withdrawal = "0.00";

  const handleLogout = () => {
    dispatch({ type: "gameData/logOut" });
    dispatch({ type: "accountData/logOut" });
    localStorage.clear();
    window.location.href = "/";
  };

  const handleDrawerOpen = () => {
    closeRules();
    openDrawer();
  };

  const handleNavClick = (route) => {
    closeDrawer();
    navigate(route);
  };

  const handleOpenBonus = () => {
    closeDrawer();
    openBonus();
  };

  const menuItems = [
    { icon: <FaHome />, label: "Home", route: "/" },
    { icon: <FaUser />, label: "My Profile", route: "/profile" },
    { icon: <FaFileAlt />, label: "Account Statement", route: "/account" },
    { icon: <FaGift />, label: "Bonus Rules", action: handleOpenBonus },
    { icon: <FaSlidersH />, label: "Stake Settings", route: "/profile?tab=stake" },
    { icon: <FaClipboardList />, label: "Unsettled Bets", route: "/report/unsetteled-bet" },
    { icon: <FaLock />, label: "Change Password", route: "/profile?tab=password" },
  ];

  return (
    <div className="mobile-header-wrapper">
      <Rules isOpen={rulesOpen} onClose={closeRules} />
      <BonusRules isOpen={bonusOpen} onClose={closeBonus} />

      {/* Dark Top Bar */}
      {/* <header className="mobile-header mobile-header--dark">
        {showBackArrow ? (
          <button
            type="button"
            aria-label="Go back"
            onClick={() => navigate(-1)}
            style={{ background: "none", border: "none", padding: "8px", cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            <FaArrowLeft style={{ color: "#fff", fontSize: "20px" }} />
          </button>
        ) : (
          <button
            type="button"
            aria-label="Open menu"
            onClick={handleDrawerOpen}
            style={{ background: "none", border: "none", padding: "8px", cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            <HiOutlineMenuAlt2 style={{ color: "#fff", fontSize: "22px" }} />
          </button>
        )}

        <a href="/" className="mobile-header__logo">
          <img src={LogoWhite} alt="IndoExch" />
        </a>

        <div className="mobile-header__spacer" />

        {!isCasinoPage && (
          <div className="mobile-header__badges">
            <div className="mobile-header__badge">
              <span className="mobile-header__badge-ribbon">BAL</span>
              <span className="mobile-header__badge-value">
                {Math.floor(Number(userData?.balance || 0) - Math.abs(Number(userData?.liability || 0)))}
              </span>
            </div>
            <div className="mobile-header__badge mobile-header__badge--exp">
              <span className="mobile-header__badge-ribbon">EXP</span>
              <span className="mobile-header__badge-value">
                {Math.floor(Math.abs(Number(userData?.liability || 0)))}
              </span>
            </div>
          </div>
        )}

      </header> */}

      {!isGamePage && !isReportPage && !hideSportsNav && (
        <>
          {/* Announcement Bar */}
          <AnnouncementBar />

          {/* Search Icon + Live Match Ticker */}
          <MobileLiveBar />

          {/* Sports Navigation */}
          <SportsNavStrip onMenuClick={() => setIsSidebarOpen && setIsSidebarOpen((prev) => !prev)} />
        </>
      )}

      {/* Drawer Navigation */}
      <Drawer isOpen={drawerOpen} placement="left" onClose={closeDrawer} size="xs">
        <DrawerOverlay bg="rgba(0,0,0,0.5)" />
        <DrawerContent style={{ backgroundColor: "#ffffff", color: "#1a1a1a" }}>
          <Flex
            align="center"
            justify="space-between"
            px="16px"
            py="14px"
            style={{ background: "#1a1a1a", borderBottom: "1px solid #333" }}
          >
            <a href="/" onClick={closeDrawer}>
              <img src={LogoWhite} alt="IndoExch" className="mobile-drawer__logo" />
            </a>
            <Button
              variant="unstyled"
              display="flex"
              alignItems="center"
              justifyContent="center"
              minW="36px"
              h="36px"
              borderRadius="50%"
              bg="#4a0000"
              _hover={{ bg: "#3a0000" }}
              _active={{ bg: "#2a0000" }}
              onClick={closeDrawer}
              aria-label="Close menu"
            >
              <FaTimes style={{ color: "#fff", fontSize: "16px" }} />
            </Button>
          </Flex>

          <DrawerBody px="0" py="0">
            {/* Red Banner */}
            <div className="dropdown-banner">
              HI, {(userData?.username || "").toUpperCase()}
            </div>

            {/* Financial Info */}
            <div className="dropdown-finance">
              <div className="dropdown-finance__row">
                <span className="dropdown-finance__label">Wallet Amount</span>
                <span className="dropdown-finance__value">{balance}</span>
              </div>
              <div className="dropdown-finance__row">
                <span className="dropdown-finance__label">Net Exposure</span>
                <span className="dropdown-finance__value dropdown-finance__value--red">{exposure}</span>
              </div>
              <div className="dropdown-finance__row">
                <span className="dropdown-finance__label">Withdrawal</span>
                <span className="dropdown-finance__value">{withdrawal}</span>
              </div>
            </div>

            {/* Menu Items */}
            <nav className="dropdown-menu-list">
              {menuItems.map((item) => (
                <a
                  key={item.label}
                  className="dropdown-menu-item"
                  onClick={item.action || (() => handleNavClick(item.route))}
                >
                  <span className="dropdown-menu-item__icon">{item.icon}</span>
                  <span>{item.label}</span>
                </a>
              ))}
            </nav>

            {/* Sign Out */}
            <Box px="12px" pb="16px">
              <button
                className="dropdown-signout-btn"
                type="button"
                onClick={handleLogout}
              >
                <FaSignOutAlt />
                SIGN OUT
              </button>
            </Box>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </div>
  );
};

export default MobileHeader;
